import { gatewayPhone } from "../../../../gateways/gatewayPhone";
import { SmsMessage } from "../chat/types/SmsMessage";

export interface PaginatedSmsSearchResponse {
  data: SmsMessage[];
  meta: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
  };
}

interface SearchSmsMessagesParams {
  q: string;
  fromNumber: string;
  companyId?: number | string | null;
  pageParam?: number;
  limit?: number;
}

export const searchSmsMessages = async ({
  q,
  fromNumber,
  companyId,
  pageParam = 1,
  limit = 20,
}: SearchSmsMessagesParams): Promise<PaginatedSmsSearchResponse> => {
  const token = sessionStorage.getItem("token");

  if (!token) {
    throw new Error("No auth token found");
  }

  const { data } = await gatewayPhone.get<PaginatedSmsSearchResponse>("inbound-records/search", {
    headers: {
      Authorization: `Bearer ${token}`,
      ...(companyId != null && { "x-company-id": String(companyId) }),
    },
    params: {
      q,
      fromNumber,
      page: pageParam,
      limit,
    },
  });

  return data;
};
